<nav class="navbar navbar-expand-sm menu-bar justify-content-between">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link action-menu" (click)="newTab()">New Tab</a>
    </li>
  </ul>
  <form class="form-inline">
    <!-- <input class="form-control filter" type="search" placeholder="Search"> -->
  </form>
</nav>

<div class="card card-default mt-3">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <iframe [src]="socialUrl" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          webkitallowfullscreen mozallowfullscreen allowfullscreen>
        </iframe>
      </div>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/social-media-monitor/social-media-monitor.component.html